import * as React from 'react'
import * as PropTypes from 'prop-types'
import LightUp from 'src/packages/lightup/LightUp'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import Space from 'src/components/Space'
import { renderString } from 'src/utils/renderCode'

const componentName = 'LightUpExample'

class LightUpExample extends React.Component {
  public static displayName = componentName

  public static propTypes = {}

  public static defaultProps = {}

  public render() {
    const cn = componentName

    return (
      <div className="light-up-example">
        <section>
          <h1>LightUp 图片预览</h1>
          <p className="text">图片放大预览组件。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">需要在用户点击后放大展示图片时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container">
            <LightUp>
              <img
                src={require('../style/imgs/gakki.png')}
                alt="gakki"
                style={{ width: '200px' }}
              />
            </LightUp>
          </div>
          <CodeBox
            title="基本用法"
            description="最基本的用法，点击图片即可放大预览。"
          >
            {renderString(`import { LightUp } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;LightUp&gt;`} />
            <Space count={4} />
            <span className="label">&lt;</span>
            <span className="htmltag">img</span>
            <span className="property"> src</span>
            <span className="htmlstr">=</span>
            <span className="htmltag">{'{'}</span>
            <span className="method">require</span>
            <span className="htmlstr">(</span>
            <span className="string">'../style/imgs/gakki.png'</span>
            <span className="htmlstr">)</span>
            <span className="htmltag">{'}'}</span>
            <span className="label"> /&gt;</span>
            <br />
            <Code code={`&lt;/LightUp&gt;`} />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>src</td>
              <td className="des">放大展示的图片路径。默认使用原图片路径</td>
              <td className="type">any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>imgClosable</td>
              <td className="des">
                点击图片是否关闭预览。默认只在点击蒙层时关闭
              </td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default LightUpExample



// WEBPACK FOOTER //
// ./src/examples/LightUp.example.tsx